// extracted by mini-css-extract-plugin
module.exports = {"middleSection":"MiddleSection-module--middle-section--2K-dd","textContainer":"MiddleSection-module--text-container--3mBA3"};